import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-disabled"]
const _hoisted_2 = ["checked", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", {
    ref: "switchEl",
    class: _normalizeClass([[_ctx.variant, { disabled: _ctx.disabled }], "switch"]),
    tabindex: "0",
    "aria-disabled": _ctx.disabled,
    onKeydown: [
      _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.onKeyToggle && _ctx.onKeyToggle(...args)), ["prevent"]), ["space"])),
      _cache[2] || (_cache[2] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.onKeyToggle && _ctx.onKeyToggle(...args)), ["prevent"]), ["enter"]))
    ]
  }, [
    _createElementVNode("input", {
      type: "checkbox",
      checked: _ctx.modelValue,
      disabled: _ctx.disabled,
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onToggle && _ctx.onToggle(...args)))
    }, null, 40, _hoisted_2),
    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "slider" }, null, -1))
  ], 42, _hoisted_1))
}